import * as React from 'react';
import {
    Button, Dimmer, Header,
} from 'semantic-ui-react';
import { tl } from 'common/services/i18nService';
import store from '../../store';
import { closeReload, ReloadMessage } from './actions';
import * as styles from './ReloadPage.scss';

interface ReloadPageProps {
    active: boolean;
    message: ReloadMessage;
}

class ReloadPage extends React.PureComponent<ReloadPageProps> {
    reloadPage = () => {
        store.dispatch(closeReload());
        window.location.reload();
    };

    render() {
        const { active, message } = this.props;

        return (
            <div>
                <Dimmer active={active} inverted page>
                    <Header className={styles.header} as="h2">
                        {tl(message.titleKey)}
                        <Header.Subheader>{tl(message.messageKey)}</Header.Subheader>
                    </Header>
                    <Button color="blue" onClick={this.reloadPage}>{tl('grading.button.reload')}</Button>
                </Dimmer>
            </div>
        );
    }
}

export default ReloadPage;
